import script from "./layoutList.vue?vue&type=script&lang=js"
export * from "./layoutList.vue?vue&type=script&lang=js"

import "./layoutList.vue?vue&type=style&index=0&id=5478766d&lang=css"
import "./layoutList.vue?vue&type=style&index=1&id=5478766d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5478766d"]])

export default __exports__